module.exports = __webpack_public_path__ + "352e1f65c55cb5b83756117e27927a43.jpg";